exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#logo {\r\n  margin-right: 20px;\r\n}\r\n\r\n.jumbotron {\r\n  background-color: #f7f7f9;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/header/header.component.css
// module id = ../../../../../src/app/header/header.component.css
// module chunks = main